import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Home, Compass, Menu, X } from 'lucide-react';

interface NavbarProps {
  className?: string;
}

export default function Navbar({ className }: NavbarProps) {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      <nav className={`navbar ${className || ''}`}>
        <div className="nav-left">
          <button className="nav-hamburger" onClick={() => setMenuOpen(true)} aria-label="Open menu">
            <Menu size={22} />
          </button>
          <Link to="/" className="nav-home nav-desktop-only">
            <Home size={20} />
          </Link>
          <Link to="/explore" className="nav-home nav-desktop-only" style={{ marginLeft: '16px' }}>
            <Compass size={20} />
          </Link>
        </div>
        <div className="nav-links">
          <a href="/blog">blog</a>
          <Link to="/info">info</Link>
          <Link to="/play">play</Link>
          <a href="/artists/">artists</a>
        </div>
        <Link to="/" className="nav-mobile-logo">album.cards</Link>
        <div className="nav-right">
          <a href="https://apps.apple.com/ca/app/album-cards/id6749836488" className="nav-cta">
            <svg width="14" height="17" viewBox="0 0 14 17" fill="currentColor" className="nav-cta-icon">
              <path d="M11.182 9.05c-.02-2.002 1.636-2.97 1.712-3.016-.935-1.366-2.388-1.553-2.904-1.573-1.228-.128-2.41.734-3.036.734-.636 0-1.604-.72-2.64-.7-1.346.02-2.598.796-3.29 2.01-1.416 2.456-.362 6.078 1.002 8.066.676.974 1.472 2.063 2.518 2.024 1.016-.042 1.398-.652 2.626-.652 1.218 0 1.572.652 2.632.63 1.09-.018 1.776-.982 2.434-1.962.782-1.122 1.096-2.222 1.112-2.28-.024-.01-2.126-.816-2.146-3.24v-.04zM9.186 3.15c.546-.678.918-1.604.816-2.54-.79.034-1.76.54-2.328 1.204-.508.588-.958 1.546-.84 2.454.886.068 1.796-.448 2.352-1.118z"/>
            </svg>
            <span className="nav-cta-text">App Store</span>
          </a>
        </div>
      </nav>

      {menuOpen && (
        <div className="mobile-menu">
          <button className="mobile-menu-close" onClick={() => setMenuOpen(false)} aria-label="Close menu">
            <X size={24} />
          </button>
          <div className="mobile-menu-links">
            <Link to="/" onClick={() => setMenuOpen(false)}>home</Link>
            <Link to="/explore" onClick={() => setMenuOpen(false)}>explore</Link>
            <a href="/blog" onClick={() => setMenuOpen(false)}>blog</a>
            <Link to="/info" onClick={() => setMenuOpen(false)}>info</Link>
            <Link to="/play" onClick={() => setMenuOpen(false)}>play</Link>
            <a href="/artists/" onClick={() => setMenuOpen(false)}>artist portal</a>
            <a href="https://apps.apple.com/ca/app/album-cards/id6749836488" onClick={() => setMenuOpen(false)}>app</a>
          </div>
        </div>
      )}
    </>
  );
}
